import React, { useState } from "react";
import {
  FaTachometerAlt,
  FaSchool,
  FaUsers,
  FaShoppingCart,
  FaHome,
  FaBars,
  FaAngleLeft,
  FaUserCircle,
  FaCog,
  FaTimes,
  FaUserAlt,
  FaUsersCog,
  FaShieldAlt,
  FaEdit,
  FaTrashAlt,
  FaSave,
  FaMapMarkerAlt,
  FaArrowLeft,
  FaPhoneAlt,
  FaEnvelope,
  FaTshirt
} from "react-icons/fa";
import { Link, Outlet, useNavigate } from "react-router-dom";
import "../App.css";
import axios from "axios";
import { API_BASE_URL } from "../config/api";
import Swal from "sweetalert2";

const passwordLetterMessage = "Password must contain at least 6 letters";
const countPasswordLetters = (value) => (String(value).match(/[A-Za-z]/g) || []).length;

function Dashboard() {
  const navigate = useNavigate();
  const username = localStorage.getItem("username") || "Admin";
  const role = localStorage.getItem("role") || "admin";

  const [isOpen, setIsOpen] = useState(true);
  const [showSettings, setShowSettings] = useState(false);
  const [showAdminProfile, setShowAdminProfile] = useState(false);
  const [showTeamGroup, setShowTeamGroup] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [teamForm, setTeamForm] = useState({
    fullName: "",
    email: "",
    username: "",
    password: "",
  });

  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");

  /* ===== PERMISSION TOGGLE ===== */
  const togglePermission = (perm) => {
    setSelectedPermissions((prev) =>
      prev.includes(perm) ? prev.filter((p) => p !== perm) : [...prev, perm],
    );
  };

  // Admin Data from localStorage (Dashboard data)
  const [adminData, setAdminData] = useState({
    fullName: localStorage.getItem("fullName") || "Admin",
    email: localStorage.getItem("email") || "admin@example.com",
    username: localStorage.getItem("username") || "admin123",
    phone: localStorage.getItem("phone") || "",
    city: localStorage.getItem("city") || "",
    address: localStorage.getItem("address") || "",
    state: localStorage.getItem("state") || "",
    role: localStorage.getItem("role") || "admin",
  });

  /* ===== SAVE TEAM MEMBER ===== */
  /* ===== SAVE TEAM MEMBER (Updated with Swal) ===== */
const handleSaveTeam = async () => {
  // Pehle check kar lette hain ki field khali toh nahi
  if (!teamForm.fullName || !teamForm.email || !teamForm.username || !teamForm.password) {
    Swal.fire({
      icon: "warning",
      title: "Missing Information",
      text: "Please fill all the details before saving.",
      confirmButtonColor: "#097969",
    });
    return;
  }

  if (countPasswordLetters(teamForm.password) < 6) {
    Swal.fire({
      icon: "warning",
      title: "Weak Password",
      text: passwordLetterMessage,
      confirmButtonColor: "#097969",
    });
    return;
  }

  try {
    const finalData = {
      ...teamForm,
      role: "staff",
      permissions: selectedPermissions,
    };

    const res = await axios.post(
      `${API_BASE_URL}/user/add-team`,
      finalData,
    );

    // ✅ Yahan alert() hata kar SweetAlert2 (Swal) laga diya hai
    Swal.fire({
      icon: "success",
      title: "Staff Added Successfully! 🎉",
      text: res.data?.message || "New team member has been registered.",
      confirmButtonColor: "#097969",
      timer: 3000, 
      showConfirmButton: true,
    });

    // Form reset logic
    setTeamForm({
      fullName: "",
      email: "",
      username: "",
      password: "",
    });
    setSelectedPermissions([]);
    setShowTeamGroup(false);
    fetchStaff(); // List refresh karne ke liye

  } catch (err) {
    // Error aane par bhi professional popup
    Swal.fire({
      icon: "error",
      title: "Registration Failed",
      text: err.response?.data?.message || "Something went wrong while adding staff!",
      confirmButtonColor: "#d33",
    });
  }
};

 const fetchStaff = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/user/team-list`);
    setStaffList(res.data);
  } catch (err) {
    console.error("Error fetching staff list", err);
  }
};

React.useEffect(() => {
  if (showTeamGroup) {
    fetchStaff();
  }
}, [showTeamGroup]);

  const fetchAdminProfile = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/user/profile/${username}`,
      );
      setAdminData(res.data);
    } catch (err) {
      console.error("Error fetching admin profile", err);
    }
  };
  
  // Jab dashboard load ho ya Settings khule, data fetch karein
  React.useEffect(() => {
    if (showAdminProfile) {
      fetchAdminProfile();
    }
  }, [showAdminProfile]);

  const handleEdit = async (data) => {
    const { value: newName } = await Swal.fire({
      title: "Update Full Name",
      input: "text",
      inputValue: data.fullName || "",
      showCancelButton: true,
      confirmButtonColor: "#097969",
      cancelButtonColor: "#d33",
    });

    if (newName) {
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: `Profile updated: ${newName}`,
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#aaa",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Deleted!", "Your account has been deleted.", "success");
      }
    });
  };

  return (
    <div
      className="d-flex"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      {/* ================= SIDEBAR (LEFT) ================= */}
      <div className={`sidebar-container ${isOpen ? "open" : "closed"}`}>
        <div className="sidebar-header d-flex justify-content-between align-items-center">
          {isOpen && <h4 className="m-0 fw-bold">Uniform nx</h4>}
          <button className="toggle-btn" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <FaAngleLeft /> : <FaBars />}
          </button>
        </div>

        <ul className="sidebar-menu list-unstyled mt-4">
          <li>
            <Link to="/dashboard">
              <FaTachometerAlt className="menu-icon" />
              {isOpen && <span>Dashboard</span>}
            </Link>
          </li>

          {(role === "admin" || permissions.includes("Add / Edit Schools")) && (
            <li>
            <Link 
    to="/dashboard/schools" 
    onClick={() => {
      // Agar aap niche wala ref use nahi kar rahe toh simple link click se page reload hoga
      // Lekin state reset karne ke liye hum window location ka use kar sakte hain
      if(window.location.pathname === "/dashboard/schools") {
        window.location.reload(); // Force reset if already on page
      }
    }}
  >
    <FaSchool className="menu-icon" />
    {isOpen && <span>Schools</span>}
  </Link>
</li>
          )}

          {/* ===== PARENTS MENU ===== */}
          {(role === "admin" || permissions.includes("View Parents")) && (
            <li>
              <Link to="/dashboard/parents">
                <FaUsers className="menu-icon" />
                {isOpen && <span>Parents</span>}
              </Link>
            </li>
          )}

          {/* ===== UNIFORMS MENU ===== */}
          {(role === "admin" ||
            permissions.includes("Add / Edit Uniform Products")) && (
            <li>
  <Link 
    to="/dashboard/uniforms" 
    onClick={() => {
      // Agar aap niche wala ref use nahi kar rahe toh simple link click se page reload hoga
      // Lekin state reset karne ke liye hum window location ka use kar sakte hain
      if(window.location.pathname === "/dashboard/uniforms") {
        window.location.reload(); // Force reset if already on page
      }
    }}
  >
    <FaTshirt className="menu-icon" />
    {isOpen && <span>Uniforms</span>}
  </Link>
</li>
          )}

          {/* ===== ORDERS MENU ===== */}
          {(role === "admin" || permissions.includes("View All Orders")) && (
            <li>
              <Link to="/dashboard/orders">
                <FaShoppingCart className="menu-icon" />
                {isOpen && <span>Orders</span>}
              </Link>
            </li>
          )}

         {(role === "admin" || permissions.includes("Manage Staff")) && (
  <li>
 <Link to="/dashboard/manage-team">
<FaUsersCog className="menu-icon"/>
{isOpen && <span>Manage Staff</span>}
</Link>
  </li>
)}

        </ul>

        <div className="sidebar-footer">
          <Link to="/dashboard" className="home-link">
            <FaHome className="menu-icon" />
            {isOpen && <span>Back to Dashboard</span>}
          </Link>
        </div>
      </div>

      {/* ================= MAIN CONTENT ================= */}
      <div className="flex-grow-1 d-flex flex-column">
        {/* Top Navbar */}
        <div className="top-nav-light shadow-sm d-flex justify-content-between align-items-center px-4 py-2">
          <div className="d-flex align-items-center gap-2">
            <h5 className="m-0 fw-bold" style={{ color: "#097969" }}>
              Admin Panel
            </h5>
          </div>

          <div className="d-flex align-items-center gap-3">
            <div className="user-profile d-flex align-items-center gap-2">
              <FaUserCircle size={22} style={{ color: "#097969" }} />
              <span className="fw-medium" style={{ color: "#555" }}>
                Welcome, <b style={{ color: "#097969" }}>{username}</b>
              </span>
            </div>

            <div
              className="settings-icon-wrapper"
              onClick={() => setShowSettings(true)}
              style={{
                cursor: "pointer",
                padding: "8px",
                borderRadius: "50%",
                background: "#f0fdf4",
              }}
            >
              <FaCog size={20} style={{ color: "#097969" }} />
            </div>

            <button
              className="logout-btn-dark"
              onClick={async () => {
                try {
                  // Call logout endpoint to clear session
                  await axios.post(`${API_BASE_URL}/user/logout`, {
                    username: username
                  });
                } catch (err) {
                  console.log("Logout API error:", err);
                }
                
                // Clear localStorage and navigate
                localStorage.clear();
                navigate("/");
              }}
            >
              Logout
            </button>
          </div>
        </div>

        <div className="p-4 bg-light flex-grow-1 overflow-auto">
          <Outlet />
        </div>
      </div>

      

      {/* ================= SETTINGS SIDEBAR ================= */}
      {showSettings && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            zIndex: 1050,
            backdropFilter: "blur(4px)",
          }}
          onClick={() => setShowSettings(false)}
        />
      )}

      <div
        style={{
          position: "fixed",
          top: 0,
          right: showSettings ? 0 : "-400px",
          width: "350px",
          height: "100%",
          background: "#fff",
          zIndex: 1060,
          transition: "0.4s ease",
          padding: "25px",
          boxShadow: "-10px 0 30px rgba(0,0,0,0.1)",
        }}
      >
        <div
          className="list-group-item d-flex align-items-center gap-3 py-4 rounded-3 mb-2 mt-4"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setShowAdminProfile(true);
            setShowSettings(false);
          }}
        >
          <div className="p-2 rounded-circle" style={{ background: "#e0f2fe" }}>
            <FaUserAlt size={30} className="text-success" />
          </div>
          <div>
            <p className="mb-0 fw-bold" style={{ fontSize: "14px" }}>
              Admin Profile
            </p>
            <small className="text-muted">View & edit admin details</small>
          </div>
          
        </div>

        {/* ================= ADMIN PROFILE PANEL (Individual Side Panel) ================= */}
        {showAdminProfile && (
          <AdminProfile
            adminData={adminData}
            setAdminData={setAdminData} // Yeh add karna zaroori hai
            onClose={() => {
              setShowAdminProfile(false);
              setShowSettings(true); // Go back to settings panel
            }}
          />
        )}

        <div className="list-group list-group-flush">
          <div
            className="list-group-item list-group-item-action border-0 d-flex align-items-center gap-3 py-3 rounded-3 mb-2"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setShowSettings(false);
              setShowTeamGroup(true);
            }}
          >
            <div
              className="p-2 rounded-circle"
              style={{ background: "#e0f2fe" }}
            >
              <FaUsersCog size={18} className="text-primary" />
            </div>
            <div>
              <p className="mb-0 fw-bold" style={{ fontSize: "14px" }}>
                Team Group
              </p>
              <small className="text-muted">Manage roles & permissions</small>
            </div> 
          </div>
        </div>
      </div>

      

      {/* ================= TEAM GROUP PANEL ================= */}
    {showTeamGroup && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.3)", // Light overlay for premium feel
      zIndex: 2000,
      display: "flex",
      justifyContent: "flex-end",
      backdropFilter: "blur(6px)", // Blur effect
    }}
  >
    {/* Main Drawer Container */}
    <div
      className="animate__animated animate__slideInRight" // Agar animation library hai toh
      style={{
        width: "100%",
        maxWidth: "550px", // Professional width
        height: "100%",
        background: "#ffffff",
        boxShadow: "-15px 0 45px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Premium Header */}
      <div className="p-4 d-flex align-items-center justify-content-between border-bottom bg-light">
        <div className="d-flex align-items-center gap-3">
          <div 
            onClick={() => {
              setShowTeamGroup(false);
              setShowSettings(true); // Go back to settings panel
            }} 
            style={{ cursor: 'pointer', background: '#fff', padding: '8px', borderRadius: '10px' }}
            className="shadow-sm border"
          >
            <FaAngleLeft size={20} color="#097969" />
          </div>
          <div>
            <h5 className="m-0 fw-bold" style={{ color: "#2d3436" }}>Add New Staff</h5>
            <small className="text-muted">Create account & set permissions</small>
          </div>
        </div>
        <FaUsersCog size={28} style={{ opacity: 0.2, color: '#097969' }} />
      </div>

      {/* Scrollable Content Area */}
      <div className="p-4 overflow-auto" style={{ flex: 1 }}>
        
        {/* Section 1: Personal Details */}
        <div className="mb-4">
          <p className="fw-bold small text-uppercase text-success mb-3" style={{ letterSpacing: '1px' }}>Personal Info</p>
          <div className="row g-3">
            {[
              { label: "Full Name", icon: <FaUserAlt />, name: "fullName", type: "text" },
              { label: "Email Address", icon: <FaEnvelope />, name: "email", type: "email" },
              { label: "Unique Username", icon: <FaShieldAlt />, name: "username", type: "text" },
              { label: "Secure Password", icon: <FaCog />, name: "password", type: "password" }
            ].map((input) => (
              <div className="col-md-6" key={input.name}>
                <label className="small fw-medium text-muted mb-1">{input.label}</label>
                <div className="input-group border rounded-3 overflow-hidden shadow-sm bg-white" style={{ transition: '0.3s' }}>
                  <span className="input-group-text border-0 bg-white text-muted ps-3 pe-2">{input.icon}</span>
                  <input
                    type={input.type}
                    className="form-control border-0 shadow-none py-2 ps-1"
                    placeholder={`Enter ${input.label.toLowerCase()}`}
                    value={teamForm[input.name]}
                    onChange={(e) => setTeamForm({ ...teamForm, [input.name]: e.target.value })}
                    style={{ fontSize: '14px' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <hr className="opacity-10 my-4" />

        {/* Section 2: Permissions Grid */}
        <div>
          <p className="fw-bold small text-uppercase text-success mb-3" style={{ letterSpacing: '1px' }}>Access Control</p>
          
          {/* Permission Group: Schools */}
          <div className="bg-light p-3 rounded-4 mb-3 border border-white shadow-sm">
             <div className="d-flex align-items-center gap-2 mb-3">
                <div className="bg-success text-white rounded-circle p-1 px-2" style={{ fontSize: '12px' }}>1</div>
                <span className="fw-bold small">Schools & Inventory</span>
             </div>
             <div className="d-flex flex-wrap gap-2">
                {["Add / Edit Schools", "Add / Edit Uniform Products", "View Stock Inventory"].map((perm) => (
                  <label key={perm} className={`permission-badge d-flex align-items-center gap-2 py-2 px-3 border rounded-pill cursor-pointer transition-all ${selectedPermissions.includes(perm) ? 'bg-success text-white border-success' : 'bg-white text-muted border-light shadow-sm'}`} style={{ cursor: 'pointer', fontSize: '12px' }}>
                    <input
                      type="checkbox"
                      className="d-none"
                      checked={selectedPermissions.includes(perm)}
                      onChange={() => togglePermission(perm)}
                    />
                    {perm}
                  </label>
                ))}
             </div>
          </div>

          {/* Permission Group: Sales */}
          <div className="bg-light p-3 rounded-4 border border-white shadow-sm">
             <div className="d-flex align-items-center gap-2 mb-3">
                <div className="bg-success text-white rounded-circle p-1 px-2" style={{ fontSize: '12px' }}>2</div>
                <span className="fw-bold small">Sales & Orders</span>
             </div>
             <div className="d-flex flex-wrap gap-2">
                {["View Total Revenue", "View All Orders", "Check Payment Status", "Generate Invoices"].map((perm) => (
                  <label key={perm} className={`permission-badge d-flex align-items-center gap-2 py-2 px-3 border rounded-pill transition-all ${selectedPermissions.includes(perm) ? 'bg-success text-white border-success' : 'bg-white text-muted border-light shadow-sm'}`} style={{ cursor: 'pointer', fontSize: '12px' }}>
                    <input
                      type="checkbox"
                      className="d-none"
                      checked={selectedPermissions.includes(perm)}
                      onChange={() => togglePermission(perm)}
                    />
                    {perm}
                  </label>
                ))}
             </div>
          </div>
        </div>
      </div>

      {/* Action Footer */}
      <div className="p-4 border-top bg-white">
        <button
          className="btn w-100 py-3 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
          onClick={handleSaveTeam}
          style={{
            background: "linear-gradient(45deg, #097969, #12a893)",
            color: "#fff",
            borderRadius: "15px",
            border: "none",
            fontSize: "15px",
            transition: '0.3s'
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
        >
          <FaSave /> CREATE TEAM ACCOUNT
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
}



function AdminProfile({ adminData, onClose, setAdminData }) {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState(adminData);

  // Update formData when adminData changes (e.g., after refresh)
  React.useEffect(() => {
    setFormData(adminData);
  }, [adminData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const saveProfile = async () => {
    const phoneRegex = /^[0-9]{10}$/;

    // 1. Validation Checks
    if (!formData.phone) {
      Swal.fire({
        icon: "error",
        title: "Required",
        text: "Phone number is empty!",
      });
      return;
    }

    if (!phoneRegex.test(formData.phone)) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Phone",
        text: "Phone number must be exactly 10 digits!",
        confirmButtonColor: "#097969",
      });
      return;
    }

    // 2. Save Logic (Actual saving starts here)
    try {
      /* Agar aapka backend ready hai toh yahan API call karein:
       await axios.put(`${API_BASE_URL}/user/update-profile/${formData.username}`, formData);
      */

      // Save to localStorage for persistence
      localStorage.setItem("fullName", formData.fullName);
      localStorage.setItem("email", formData.email);
      localStorage.setItem("phone", formData.phone);
      localStorage.setItem("city", formData.city);
      localStorage.setItem("address", formData.address);
      localStorage.setItem("state", formData.state);

      // Dashboard UI update karne ke liye (agar props se aa raha hai)
      if (typeof setAdminData === "function") {
        setAdminData(formData);
      }

      // Success Message
      Swal.fire({
        icon: "success",
        title: "Saved!",
        text: "Profile updated successfully",
        timer: 1500,
        showConfirmButton: false,
      });

      // 3. Sabse important: Edit mode ko band karein
      setIsEditing(false);
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: "Failed to save data" });
      console.error(err);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        width: "420px",
        height: "100%",
        background: "#f8f9fa",
        zIndex: 2000,
        boxShadow: "-10px 0 30px rgba(0,0,0,0.1)",
        overflowY: "auto",
        transition: "all 0.3s ease",
      }}
    >
      {/* Header */}
      <div className="p-4 bg-white border-bottom d-flex justify-content-between align-items-center">
        <h5 className="fw-bold m-0" style={{ color: "#097969" }}>
          Admin Settings
        </h5>
        <button className="btn-close" onClick={onClose}></button>
      </div>

      <div className="p-4">
        {/* Profile Card Section */}
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden mb-4">
          <div
            className="card-body text-center pt-5 pb-4"
            style={{
              background: "linear-gradient(180deg, #097969 80px, white 80px)",
            }}
          >
            <div className="position-relative d-inline-block mb-3">
              <FaUserCircle
                size={100}
                color="#fff"
                style={{
                  background: "#097969",
                  borderRadius: "50%",
                  border: "4px solid white",
                }}
              />
            </div>
            <h5 className="fw-bold mb-1">{formData.fullName}</h5>
            <p className="text-muted small mb-3">@{formData.username}</p>

            {!isEditing && (
              <button
                className="btn btn-sm px-4 rounded-pill btn-outline-success"
                onClick={() => setIsEditing(true)}
              >
                <FaEdit className="me-1" /> Edit Profile
              </button>
            )}
          </div>
        </div>

        {/* Dynamic Content: View vs Edit */}
        <div className="card border-0 shadow-sm rounded-4 p-4">
          {!isEditing ? (
            /* --- VIEW MODE --- */
            <div className="profile-details">
              <h6 className="fw-bold mb-4 text-secondary">
                Contact Information
              </h6>
              <DetailRow
                icon={<FaEnvelope />}
                label="Email"
                value={formData.email}
              />
              <DetailRow
                icon={<FaPhoneAlt />}
                label="Phone"
                value={formData.phone}
              />
              <DetailRow
                icon={<FaMapMarkerAlt />}
                label="City"
                value={formData.city}
              />
            </div>
          ) : (
            /* --- EDIT MODE --- */
            <div className="edit-form">
              <h6 className="fw-bold mb-4 text-primary">Update Details</h6>
              {/* Edit Mode ke andar loop ko aise update karein */}
              {["fullName", "email", "phone", "city"].map((field) => (
                <div className="mb-3" key={field}>
                  <label className="fw-bold small text-muted text-capitalize">
                    {field}
                  </label>

                  {field === "phone" ? (
                    /* --- YE RHA PHONE KA VALIDATION INPUT --- */
                    <div className="input-group input-group-sm">
                      <span className="input-group-text bg-light">+91</span>
                      <input
                        type="text"
                        name="phone"
                        className="form-control form-control-sm shadow-none"
                        placeholder="Enter 10 digits"
                        value={formData.phone}
                        maxLength={10}
                        onChange={(e) => {
                          // Sirf Numbers allow karne ke liye logic
                          const value = e.target.value.replace(/\D/g, "");
                          setFormData({ ...formData, phone: value });
                        }}
                      />
                    </div>
                  ) : (
                    /* --- BAAKI FIELDS KE LIYE NORMAL INPUT --- */
                    <input
                      type="text"
                      className="form-control form-control-sm shadow-none"
                      name={field}
                      value={formData[field]}
                      onChange={handleInputChange}
                    />
                  )}

                  {/* Chota counter dikhane ke liye (Optional par acha lagta hai) */}
                  {field === "phone" && (
                    <small
                      className={`text-${formData.phone.length === 10 ? "success" : "danger"}`}
                      style={{ fontSize: "10px" }}
                    >
                      {formData.phone.length}
                    </small>
                  )}
                </div>
              ))}
              <div className="d-flex gap-2 mt-4">
                <button
                  className="btn btn-success flex-grow-1"
                  onClick={saveProfile}
                >
                  <FaSave className="me-2" /> Save
                </button>
                <button
                  className="btn btn-light flex-grow-1 border"
                  onClick={() => setIsEditing(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Dangerous Zone */}
        {!isEditing && (
          <div className="mt-5 pt-4 border-top">
            <p className="text-muted small mb-2">Danger Zone</p>
            <button
              className="btn btn-outline-danger w-100 border-0 text-start d-flex align-items-center"
              onClick={() =>
                Swal.fire("Deleted!", "Account removal requested.", "success")
              }
            >
              <FaTrashAlt className="me-3" /> <span>Delete</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// Reusable component for View Mode rows
function DetailRow({ icon, label, value }) {
  return (
    <div className="d-flex align-items-center mb-3">
      <div className="text-success me-3 opacity-75">{icon}</div>
      <div>
        <small className="text-muted d-block" style={{ fontSize: "11px" }}>
          {label}
        </small>
        <span className="fw-medium">{value}</span>
      </div>
    </div>
  );
}

export default Dashboard;
